import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import FlowButton from './FlowButton';

function SolutionButton ({onClick}) {
    
    return <FlowButton className='baseElementsconfirmButton' onClick={onClick} name={"Mostrami la soluzione"}></FlowButton>
}

export default SolutionButton;